import { glideLocalStorage } from "../glideLocalStorage";

export async function getAccount() {
  const address =
    (await glideLocalStorage.getItem("glide.solana.account")) || undefined;
  const isConnected = !!address;
  return { address, isConnected };
}
